function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
}

function endOfDay(d) {
    const x = new Date(d);
    x.setHours(23, 59, 59, 0);
    return x;
}

function addDays(d, n) {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
}

export const DATE_INTERVAL_PRESETS = [
    {
        id: 'last_7_days',
        label: 'Últimos 7 dias',
        resolve: () => {
            const now = new Date();
            return { from: startOfDay(addDays(now, -6)), to: endOfDay(now) };
        },
    },
    {
        id: 'last_30_days',
        label: 'Últimos 30 dias',
        resolve: () => {
            const now = new Date();
            return { from: startOfDay(addDays(now, -29)), to: endOfDay(now) };
        },
    },
    {
        id: 'this_month',
        label: 'Este mês',
        resolve: () => {
            const now = new Date();
            const from = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
            return { from, to: endOfDay(now) };
        },
    },
    {
        id: 'last_month',
        label: 'Mês passado',
        resolve: () => {
            const now = new Date();
            const from = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0);
            const to = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 0);
            return { from, to };
        },
    },
    {
        id: 'this_quarter',
        label: 'Este trimestre',
        resolve: () => {
            const now = new Date();
            const quarterMonth = Math.floor(now.getMonth() / 3) * 3;
            const from = new Date(now.getFullYear(), quarterMonth, 1, 0, 0, 0, 0);
            return { from, to: endOfDay(now) };
        },
    },
    {
        id: 'this_year',
        label: 'Este ano',
        resolve: () => {
            const now = new Date();
            const from = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);
            return { from, to: endOfDay(now) };
        },
    },
];

export const DATE_INTERVAL_PRESET_MAP = DATE_INTERVAL_PRESETS.reduce((acc, p) => {
    acc[p.id] = p;
    return acc;
}, {});

function pad(n) {
    return String(n).padStart(2, '0');
}

export function toApiDate(d) {
    if (!d) return null;
    const date = d instanceof Date ? d : new Date(d);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function toDisplayDate(d) {
    if (!d) return '';
    const date = d instanceof Date ? d : new Date(d);
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}
